// extracted by mini-css-extract-plugin
export default {"container":"ConditionOfUse_container__yNUTb","condition_title":"ConditionOfUse_condition_title__4a5+O","condition_content":"ConditionOfUse_condition_content__n4ZMn"};